import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';

@Component({
  selector: 'upsell-details',
  templateUrl: './upsell-details.component.html',
  styleUrl: './upsell-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellDetailsComponent {
  @Input() flightItineraries: PortalFlightItineraryGroupNode[];
}
